import Layout from 'antd/lib/layout/layout'
import styled from 'styled-components'

export const Container = styled.div`
    max-width: 100%;
    margin: 0 auto;
    padding: 0 1rem;

    @media (min-width: 576px) {
        max-width: 576px;
    }

    @media (min-width: 768px) {
        max-width: 768px;
    }

    @media (min-width: 992px) {
        max-width: 992px;
    }

    @media (min-width: 1200px) {
        max-width: 1200px;
    }
`

export const StyledLayout = styled(Layout)`
    overflow-y: scroll;
`

export const Main = styled.div`
    padding: 20px 50px;
    margin-top: 10px;

    /* header row containing the button */
    .header-row {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 15px;
    }

    .userList {
        padding: 0px 15px;
        background-color: white;
        border: 1px solid white;
        border-radius: 5px;
        .ant-table-thead th {
            color: #a2a2a2;
            border-bottom: 2px solid #e1e1e1 !important;
        }
        .ant-table-tbody td {
            border-bottom: 1px solid #e1e1e1;
            font-weight: 600;
        }
        .ant-table-tbody tr:last-child td {
            border-bottom: 2px solid #e1e1e1 !important  ;
        }
    }
`
export const UserInfoCell = styled.div`
    display: flex;
    align-items: center;
    img {
        margin-right: 5px;
        border-radius: 100%;
        background-color: gray;
    }
`

export const PaginationBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    padding-bottom: 20px;
    .description {
        color: gray;
        .hightlight {
            font-weight: 700;
        }
    }
    .page-buttons {
        button {
            margin-left: 3px;
            margin-right: 3px;
            background-color: white;
            border-color: white;
            color: black;
        }
        button.selected {
            border-color: gray;
        }
    }
    .page-toolbar {
        display: flex;
        aling-items: center;
        .page-size-select {
            &:hover {
                cursor: pointer;
            }
            color: gray;
            margin-right: 5px;
            margin-top: 5px;
        }
        .page-action-buttons {
            margin-left: 5px;
            button {
                background: white;
                border: white;
                color: gray;
            }
        }
    }
`
